<template>
    <div class="full-cut-detail-wrap">
        <div class="header-return">
            <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            <h2>{{luckyDrawName || '新建'}}</h2>
        </div>
        <el-tabs v-model="tabSel" tab-position="top" type="border-card">
            <el-tab-pane label="编辑" name="tab0">
                <luckydrawEdit></luckydrawEdit>
            </el-tab-pane>
            <el-tab-pane  label="添加奖品" name="tab1">
                <prizeList></prizeList>
            </el-tab-pane>
            <el-tab-pane  label="查看预约/中奖用户" name="tab2">
                <luckydrawUserList></luckydrawUserList>
            </el-tab-pane>

        </el-tabs>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import luckydrawEdit from '@/views/lucky/luckydrawEdit'
    import luckydrawUserList from '@/views/lucky/luckydrawUserList'
    import prizeList from '@/views/lucky/prizeList'

    //定义组件
    export default {
        data() {
            return {
                tabSel: this.$route.query.curTab || 'tab0',
                bindCode: this.$route.query.bindCode,
                id: this.$route.query.id,
                luckyDrawName: this.$route.query.luckyDrawName,
            }
        },
        components: {
            luckydrawEdit,
            luckydrawUserList,
            prizeList,
        },
        methods: {
            returnHistory(){
                window.history.back()
            },
            getGrouponShow(activeType){
                return activeType == 23;
            },
        },
        watch: {
            '$route'(to, from) {
                // 对路由变化作出响应...
                console.log("路由变了")
                if (this.$route.query.activeNo != '') {
                    console.log("路由变了reload")
                    location.reload();
                }
            }
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
    .full-cut-detail-wrap {
        padding: 10px;
        .header-return {
            margin-bottom: 20px;
            border-bottom: 1px solid #eeeeee;
            padding-bottom: 10px;
            position: relative;
            h2 {
                text-align: center;
                position: absolute;
                left: 50%;
                top: 0;
                margin: 0;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/views/lucky/luckytabs.vue